import React from "react";
import openSquirrelUrl from "open-squirrel.svg";
import styles from "components/settings/no-settings.scss";

export const NoHistoricalInvoices = () => (
  <div>
    <div className={ styles.container }>
      <img alt={ "open arms squirrel" } className={ styles.squirrel } src={ openSquirrelUrl } />
      <h3>It doesn&apos;t look like you have any billing history.</h3>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/js/components/settings/no-historical-invoices.jsx